import {
  DeleteFeedItemInput,
  DeleteFeedItemResult,
} from '../types/adminPortalApiSchema';
import { queryAPI } from '../utils/queryApi';
import gql from 'fake-tag';

export async function deleteCommunityActivity(
  input: DeleteFeedItemInput
): Promise<DeleteFeedItemResult> {
  const result = await queryAPI<{
    deleteFeedItem: DeleteFeedItemResult;
  }>(
    gql`
      mutation DeleteFeedItem($input: DeleteFeedItemInput!) {
        deleteFeedItem(input: $input) {
          success
        }
      }
    `,
    { input }
  );

  if (result.errors) {
    throw new Error(result.errors[0].message);
  }
  return { success: result.data.deleteFeedItem.success };
}
